import { makeRequest } from 'utils/requestLogger';

export default (user_id) => makeRequest('post', `/api/courses/remove_from_sample`, { user_id });



// WEBPACK FOOTER //
// ./src/app/services/courses/removeSampleCourse.js